<template>
  <t-layout :showNav="false">
    <div class="debug">
      <div>ver_no：{{ ver_no }}</div>
    </div>
    <!-- :style="`top: ${isShowNav ? '92rpx': '0'}`" -->
    <div class="list-page">
      <div class="tabs">
        <div class="tab" v-for="(item, index) in tabs" :key="index" @click="switchTab(index)">
          <span :class="selected == index ? 'selected' : ''">{{ item.tab }}</span>
        </div>
      </div>
      <div class="notice">受中国福利彩票规定，暂不支持自主选号~</div>
<!--      <div class="notice">1月27日至2月5日休市，暂停取号开奖兑奖，2月6日恢复～ </div>-->

      <div v-if="list.length" class="container">
        <div v-for="(item, index) in list" :key="index" class="coupon-wrap">
          <div
            v-for="(coupon, i) in item.coupon_list"
            :key="i"
            @click="toCouponDetail(coupon)"
            class="coupon"
          >
            <div class="left">
              <img class="cover" :src="coupon.cover" />
            </div>
            <div class="middle">
              <span class="title ellipsis">{{ coupon.title }}</span>
              <span class="explain ellipsis-2">{{ coupon.sub_title }}</span>
            </div>

            <!-- 1-未使用，2-已使用，3-已过期 4-兑换失败 5-已中奖 -->
            <div class="right">
              <div class="pick" v-if="coupon.status == 1">待领取</div>
              <div class="pick" v-if="coupon.status == 2 || coupon.status == 5">已领取</div>
              <div class="pick" v-if="coupon.status == 3">已过期</div>
              <div class="pick" v-if="coupon.status == 4">领取失败</div>

              <div class="btn" v-if="coupon.status == 1">去领取</div>
              <div class="btn btn-2" v-if="coupon.status == 2">查看开奖</div>
              <div class="btn btn-5" v-if="coupon.status == 4">再次领取</div>
              <div class="btn btn-3" v-if="coupon.status == 5">已中奖</div>
            </div>

            <div class="divider" v-if="shouldShowTime(coupon.status)"></div>
            <div class="receive-time" v-if="shouldShowTime(coupon.status)">
              <span v-if="coupon.status === 1">领券时间：{{ coupon.created_at }}</span>
              <span v-if="coupon.status === 2 || coupon.status === 5">领号时间：{{ coupon.lottery_created_at }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-coupon">暂无可使用福袋券~</div>

      <tabbar :current="0"></tabbar>
    </div>
  </t-layout>
</template>

<script>
import tabbar from '../components/tabbar/index'

export default {
  name: 'shopLotteryView',
  components: {
    tabbar
  },
  data() {
    return {
      isShowNav: true,

      tabs: [
        { status: 0, tab: '全部' },
        { status: 1, tab: '待领取' },
        { status: 2, tab: '已领取' },
        { status: 5, tab: '已中奖' }
      ],
      selected: 0,
      list: [],
      ver_no: 1,
      create_ver_no: 1,
      time_ver_no: 1,
      ready_ver_no: 1
    }
  },
  created() {
    console.log('created')
    const options = this.$route.query
    if (options.token) {
      let token = decodeURIComponent(options.token)
      localStorage.setItem('token', token)
    }

    // if (options.ver_no) {
    //   this.ver_no = options.ver_no
    // }
  },
  activated() {
    console.log('activated')
    this.$store.commit('setTitle', '彩票券')
    this.isShowNav = !this.$t.getEnv()
    let selected = this.$route.query.selected
    let ver_no = this.$route.query.ver_no
    if (selected) {
      console.log('selected', selected)
      this.selected = Number(selected)
    }
    if (ver_no) {
      this.ver_no = ver_no
      console.log('ver_no', this.ver_no)
    }

    this.getUserShopCoupon()
  },
  methods: {
    shouldShowTime(status) {
      // 只有状态为1(待领取)、2(已领取)、5(已中奖)时才显示时间
      return [1, 2, 5].includes(status)
    },

    getUserShopCoupon() {
      let status = this.tabs[this.selected].status
      this.$api.coupon.getUserLotteryList({ type: 6, status }).then(res => {
        const data = res.data

        if (data.code == 0) {
          this.list = data.data.list.map(group => ({
            ...group,
            coupon_list: group.coupon_list.map(coupon => ({
              ...coupon,
              receive_time: this.formatTime(coupon.receive_time)
            }))
          }))
        }
      })
    },

    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`
    },

    switchTab(i) {
      window.scrollTo(0, 0)
      this.selected = i
      this.getUserShopCoupon()
    },

    async toCouponDetail(item) {
      let result = await this.$api.user.getUserInfo()
      let data = result.data
      if (data.code == 0) {
        let userInfo = data.data.user_info
        if (userInfo.mobile) {
          if (item.status == 3) return
          if (item.status == 1 || item.status == 4) {
            if (this.ver_no == 2) {
              this.getLotteryAddress('create', item, url => {
                this.$router.push({
                  path: `/lottery/issueTicket?id=${item.id}&user_coupon_id=${
                    item.user_coupon_id
                  }&url=${encodeURIComponent(url)}`
                })
              })
            } else {
              this.getLotteryAddress('create', item)
            }
          } else {
            this.$router.push({
              path: `/lottery/detail?from=user&id=${item.id}&user_coupon_id=${item.user_coupon_id}`
            })
          }
        } else {
          this.$eventBus.$emit('haddleLogin')
        }
      }
    },

    getLotteryAddress(type, item, cb) {
      let { user_coupon_id } = item
      this.$api.coupon.getLotteryAddress({ type, user_coupon_id }).then(result => {
        let res = result.data
        if (res.code == 0) {
          const { url } = res.data

          if (cb) {
            cb(url)
          } else {
            window.location.href = url
          }
        }
      })
    }
  }
}
</script>
<style>
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
<style lang="less" scoped>
.debug {
  position: fixed;
  right: 10rpx;
  bottom: 10rpx;
  padding: 5px 10px;
  background: green;
  z-index: 9999;
  color: #fff;
  font-size: 24rpx;
  line-height: 24rpx;
  display: none;
}

.list-page {
  padding-top: 160rpx;
  padding-bottom: 168rpx;
}

.tabs {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  background-color: #fff;
  font-size: 26rpx;
  z-index: 9;

  .tab {
    text-align: center;
    width: 25%;

    span {
      display: block;
      height: 96rpx;
      line-height: 96rpx;
      color: #808991;
      position: relative;
      letter-spacing: 2rpx;
    }

    span.selected {
      font-weight: 600;
      color: #353738;

      &::after {
        content: '';
        height: 4rpx;
        width: 48rpx;
        border-radius: 4rpx;
        background: #353738;
        position: absolute;
        bottom: 6rpx;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.notice {
  position: fixed;
  left: 0;
  top: 96rpx;
  z-index: 9;
  width: 100%;
  height: 64rpx;
  background-color: #fff1f4;
  color: #ff5566;
  font-size: 26rpx;
  line-height: 64rpx;
  padding-left: 68rpx;
  background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/notice-icon.png');
  background-position: 24rpx center;
  background-repeat: no-repeat;
  background-size: 32rpx 32rpx;
}

.container {
  padding: 20rpx 24rpx;
}

.no-coupon {
  width: 514rpx;
  height: 350rpx;
  margin-top: 300rpx;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 30rpx;
  color: #9b9b9b;
  background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/img-blank.png) no-repeat
    top center;
  background-size: 100% 298rpx;
}

.coupon {
  width: 100%;
  background: #fff;
  display: flex;
  padding: 24rpx;
  margin-bottom: 20rpx;
  overflow: hidden;
  position: relative;
  flex-wrap: wrap;

  .left {
    width: 128rpx;
    height: 128rpx;
    margin-right: 16rpx;

    .cover {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .middle {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      max-width: 100%;
      font-size: 30rpx;
      line-height: 30rpx;
      margin-bottom: 16rpx;
      color: #353738;
    }

    .explain {
      max-width: 100%;
      font-size: 26rpx;
      line-height: 34rpx;
      color: #a1a7ad;
      margin-bottom: 12rpx;
    }
  }

  .right {
    width: 150rpx;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-top: 4rpx;

    .pick {
      color: #a1a7ad;
      font-size: 26rpx;
    }

    .btn {
      margin-top: 42rpx;
      width: 140rpx;
      height: 48rpx;
      border-radius: 24rpx;
      background: #ff5566;
      border: 2rpx solid #ff5566;
      text-align: center;
      line-height: 48rpx;
      color: #fff;
      font-size: 26rpx;

      &.btn-2 {
        background: #fff;
        color: #ff5566;
      }

      &.btn-3 {
        background: #fff1f4;
        border: 2rpx solid #fff1f4;
        color: #ff5566;
      }

      &.btn-4 {
        background: #f7f8fa;
        border: 2rpx solid #f7f8fa;
        color: #9b9b9b;
      }

      &.btn-5 {
        background: #fff;
        border: 2rpx solid #5e656b;
        color: #5e656b;
      }
    }
  }

  .divider {
    width: 100%;
    height: 1px;
    border-top: 1px dashed #E5E6EB;
    margin: 16rpx 0 12rpx;
  }

  .receive-time {
    width: 100%;
    font-size: 24rpx;
    color: #a1a7ad;
    line-height: 24rpx;
  }
}
</style>
